const listeners = new Set()

export function listen(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const stack = []

export function emit(emitter, event) {
  let emitterIndex = stack.findIndex(item => item.emitter === emitter)

  if (event) {
    // 'show' event

    if (emitterIndex < 0) {
      // The emitter is not found in the stack, add it to the top
      stack.unshift({ emitter, event })
      emitterIndex = 0
    } else {
      // The emitter is found, update its current event
      stack[emitterIndex].event = event
    }
  } else {
    // 'hide' event

    if (emitterIndex >= 0) {
      // remove the previous emitter if found in the stack
      stack.splice(emitterIndex, 1)
    }
  }

  if (emitterIndex === 0) {
    // The current 'emit' was called by the topmost emitter, update the tooltip
    const eventToTrigger = stack.length ? stack[0].event : false
    listeners.forEach(listener => listener(eventToTrigger))
  }
}
